module.exports = __webpack_public_path__ + "static/media/adsum-redes.53172eff.svg";